import {action, makeObservable, observable} from "mobx";

export class PromptDataStore {
  id = "";
  name = "";
  category = "";
  shortDescription = "";
  promptContent = "";
  updatedAt = "";
  hash = "";

  constructor() {
    makeObservable(this, {
      id: observable,
      hash: observable,
      name: observable,
      category: observable,
      shortDescription: observable,
      promptContent: observable,
      updatedAt: observable,
      setData: action,
    });
  }
  
  setData({ id, hash, name, category, shortDescription, promptContent, updatedAt }) {
    this.id = id;
    this.hash = hash;
    this.name = name;
    this.category = category;
    this.shortDescription = shortDescription;
    this.promptContent = promptContent;
    this.updatedAt = updatedAt;
  }
  
  onChangeField(field, value) {
    this[field] = value;
  }
}